import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EnrollmentCheckoutType } from "src/app/constants/enrollment-checkout-type";
import { MaskType } from "src/app/constants/masks";
import { otpType } from "src/app/constants/otp";
import { OTPResponse } from "src/app/models/auth";
import { CheckoutFinalize, CheckoutFinalizePayload, CheckoutVerificationCode } from "src/app/models/enrollment-checkout";
import { EnumModel } from "src/app/models/enum-model";
import { EnrollmentCheckoutService } from "src/app/services/enrollment-checkout.service";
import { FormValidationService } from "src/app/services/form-validation.service";
import { HelperService } from "src/app/services/helper.service";
import { MaskService } from "src/app/services/mask.service";
import { SessionService } from "src/app/services/storage/session.service";

@Component({
    selector: 'mwp-benefit-enrollment-checkout-finalize-otp',
    templateUrl: './otp.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckoutFinalizeOTPComponent implements OnInit, AfterContentChecked {
    @Input() public checkoutFinalize: CheckoutFinalize;

    @Output() public emitCancel: EventEmitter<any> = new EventEmitter();
    @Output() public emitComplete: EventEmitter<any> = new EventEmitter();

    public otpComplete: boolean;
    public otpTypes = otpType;
    public displayVerifyOTPForm: boolean;
    public verifyOtpForm: FormGroup;
    public verfyButtonName: string = 'Verify Code';
    public displayForm: boolean;
    public otpForm: FormGroup;
    public otpInputName: string = 'otpInput';
    public otpInputMemberCallerId: string = 'otpInputMemberCallerId';
    public otpInputVerifyCodeName: string = 'otpInputVerifyCode';
    public otpInputIsPassword: boolean;
    public otpInputIsVerifyCode: boolean;
    public otpLabelName: string;
    public otpButtonName: string;
    public disaplyOTPCallerIDINput: boolean;
    public maskType = MaskType;
    public otpMaskType: MaskType;
    public selectedOTPType: string;
    public selectedCheckoutType: string;
    public agentName: string;;
    public memberName: string;;
    public displayError: boolean;
    public registrationErrorMessage: string;
    public otpEmail: string;
    public otpPhoneNumber: string;

    constructor(
        private formBuilder: FormBuilder,
        private maskService: MaskService,
        private enrollmentCheckoutService: EnrollmentCheckoutService,
        private sessionServie: SessionService,
        private helperService: HelperService,
        private cd: ChangeDetectorRef,
    ) {
        this.agentName = this.sessionServie.session.agent.name;
        this.memberName = this.sessionServie.session.member.memberName;
    }

    ngOnInit(): void {
    }

    ngAfterContentChecked(): void {
        this.cd.detectChanges();
    }

    public otpSelection(otp: EnumModel): void {
        this.selectedOTPType = otp.value;
        this.buildOTPForm();
    }

    private buildOTPForm(): void {
        this.displayForm =
            this.displayVerifyOTPForm =
            this.disaplyOTPCallerIDINput =
            this.otpInputIsVerifyCode =
            this.otpInputIsPassword =
            this.otpComplete = false;

        this.verifyOtpForm = null;
        this.otpForm = null;

        switch (this.selectedOTPType) {
            case otpType.email:
                this.otpForm = this.formBuilder.group({
                    [this.otpInputName]: [this.checkoutFinalize.homeEmail, [Validators.required, Validators.compose([FormValidationService.validEmail(true)])]],
                });
                this.otpLabelName = this.selectedOTPType;
                this.otpButtonName = 'Request Code';
                this.selectedCheckoutType = EnrollmentCheckoutType.agentCallCenterEmail;
                this.otpMaskType = MaskType.none;
                break;

            case otpType.phone:
            case otpType.sms:
                this.otpForm = this.formBuilder.group({
                    [this.otpInputName]: [this.maskService.phoneFormatInbound(this.checkoutFinalize.memberPhone), [Validators.required, Validators.compose([FormValidationService.validPhoneNumber(true)])]],
                });

                this.otpLabelName = 'Phone Number';
                this.selectedCheckoutType = EnrollmentCheckoutType.agentCallCenterPhone;

                if (this.selectedOTPType == otpType.sms) {
                    this.otpLabelName = `SMS ${this.otpLabelName}`;
                    this.selectedCheckoutType = EnrollmentCheckoutType.agentCallCenterSMS;
                }

                this.otpButtonName = 'Request Code';
                this.otpMaskType = MaskType.phone;
                break;

            case otpType.voiceSignature:
                this.otpForm = this.formBuilder.group({
                    [this.otpInputName]: [null, Validators.required],
                    [this.otpInputMemberCallerId]: [null, [Validators.required, Validators.compose([FormValidationService.validPhoneNumber(true)])]],
                });
                this.otpLabelName = 'Counselor Password';
                this.otpButtonName = 'Verify Voice Signature';
                this.otpMaskType = MaskType.none;
                this.otpInputIsPassword = true;
                this.selectedCheckoutType = EnrollmentCheckoutType.agentCallCenterOverride;
                this.disaplyOTPCallerIDINput = true;
                break;
        }
        this.otpForm.updateValueAndValidity();
        this.displayForm = true;
    }

    public otpCodeRequestSubmit(): void {
        let l_CheckoutFinalizePayload: CheckoutFinalizePayload = new CheckoutFinalizePayload();
        let l_CheckoutVerificationCode: CheckoutVerificationCode = new CheckoutVerificationCode();
        let l_GetOTPCode: boolean;
        let l_OTPCodeVerify: boolean;

        l_CheckoutVerificationCode.checkoutMethod =
            l_CheckoutFinalizePayload.checkoutMethod = this.selectedCheckoutType;

        switch (this.selectedOTPType) {
            case otpType.email:
                l_CheckoutFinalizePayload.email = 
                    this.otpEmail = this.otpForm.get(this.otpInputName).value;
                l_CheckoutFinalizePayload.phoneNumber = 
                    this.otpPhoneNumber = this.maskService.phoneFormatInbound(this.checkoutFinalize.memberPhone);
                l_GetOTPCode = true;
                break;

            case otpType.phone:
            case otpType.sms:
                l_CheckoutFinalizePayload.email = 
                    this.otpEmail = this.checkoutFinalize.homeEmail;
                l_CheckoutFinalizePayload.phoneNumber = 
                    this.otpPhoneNumber = this.otpForm.get(this.otpInputName).value;
                l_GetOTPCode = true;
                break;

            case otpType.voiceSignature:
                l_CheckoutFinalizePayload.agentPassword = this.otpForm.get(this.otpInputName).value;
                l_CheckoutFinalizePayload.callerID = this.otpForm.get(this.otpInputMemberCallerId).value;
                l_CheckoutFinalizePayload.email = this.checkoutFinalize.homeEmail;
                l_CheckoutFinalizePayload.phoneNumber = this.maskService.phoneFormatInbound(this.checkoutFinalize.memberPhone);
                l_GetOTPCode = true;
                break;
        }

        if (l_GetOTPCode)
            this.enrollmentCheckoutService.submitFinalizeOtpCode(l_CheckoutFinalizePayload).subscribe((response: OTPResponse) => {
                if (response.isVerificationSent) {
                    this.verifyOtpForm = this.formBuilder.group({
                        checkoutMethod: [this.selectedCheckoutType, Validators.required],
                        code: [null, Validators.required],
                    });
                    this.displayVerifyOTPForm = true;
                    this.displayForm = false;
                } else {
                    if (this.selectedOTPType == otpType.voiceSignature && !response.registrationReturnMessage) {
                        this.otpComplete = true;
                        this.emitComplete.emit();
                    } else {
                        this.registrationErrorMessage = response.registrationReturnMessage;
                        this.displayError = true;
                        this.displayForm = false;
                    }
                }
            });

        if (l_OTPCodeVerify)
            this.otpVerification(l_CheckoutVerificationCode);
    }

    public verifyCode(): void {
        const l_CheckoutVerificationCode: CheckoutVerificationCode = this.helperService.convertFormGroupIntoObject(this.verifyOtpForm, new CheckoutVerificationCode());
        if (!l_CheckoutVerificationCode.email)
            l_CheckoutVerificationCode.email = this.otpEmail;

        if (!l_CheckoutVerificationCode.phoneNumber)
            l_CheckoutVerificationCode.phoneNumber = this.otpPhoneNumber;
        
        this.otpVerification(l_CheckoutVerificationCode);
    }

    private otpVerification(payload: CheckoutVerificationCode): void {
        this.enrollmentCheckoutService.submitFinalizeOtpVerification(payload).subscribe(() => {
            this.otpComplete = true;
            this.emitComplete.emit();
        });
    }

    public cancelError(): void {
        this.displayError = false;
        this.registrationErrorMessage = null;
        this.displayForm = true;
    }

    public reloadFormToEmail(): void {
        this.selectedOTPType = otpType.email;
        this.displayError = false;
        this.registrationErrorMessage = null;
        this.buildOTPForm();
    }
}